import {createSlice}  from '@reduxjs/toolkit';

const accountSummarySlice = createSlice({
    name: 'accountsummary',
    initialState: { 
        callAccountDetailsApi: false,
        bypassAccountDetailsCache: false,
        accountDetailsCacheTimeStampValue: "555555",
        details: null,
        updatedCustNo: '', 
        updatedAddress: '', 
        updatedZipValue: '', 
        initialLoading: true, 
        displayPrePayButton: false,
        displayEasyPayButton: false,
        preferredEmail:'', 
        accountSummaryData: null,
        isOverlayLoading: false,
        selectedServiceAddress: null,
        addressSelectionTimestamp: null,
        easyPayEnrollAgrNum: []
    },
    reducers: {
      setCallAccountDetailsApi: (state, action) => {
        state.callAccountDetailsApi = action.payload;
      },
      setAccountDetails: (state, action) => {
        state.details = action.payload;
      },
      setBypassAccountDetailsCache: (state, action) => {
        state.bypassAccountDetailsCache = action.payload;
      },
      setAccountDetailsCacheTimeStampValue: (state, action) => {
        state.accountDetailsCacheTimeStampValue = action.payload;
      },
      setUpdatedCustNo: (state, action) => {
          state.updatedCustNo = action.payload;
      },
      setUpdatedAddress: (state, action) => {
          state.updatedAddress = action.payload;
      },
      setUpdatedZipValue: (state, action) => {
          state.updatedZipValue = action.payload;
      },
      setInitialLoading: (state, action) => {
          state.initialLoading = action.payload;
      },
      setDisplayPrePayButton: (state, action) => {
        state.displayPrePayButton = action.payload;
      },
      setDisplayEasyPayButton: (state, action) => {
        state.displayEasyPayButton = action.payload;
      },
      setPreferredEmail: (state, action) => {
          state.preferredEmail = action.payload
      },
      setAccountSummaryData: (state, action) => {
          state.accountSummaryData = action.payload;
      },
      setIsOverlayLoading: (state, action) => {
          state.isOverlayLoading = action.payload;
      },
      setSelectedServiceAddress: (state, action) => {
          state.selectedServiceAddress = action.payload;
          state.addressSelectionTimestamp = Date.now();
      },
      setEasyPayEnrollAgrNum : (state, action) => {
        state.easyPayEnrollAgrNum = action.payload;
      }
    }
});
  
export const { 
  setCallAccountDetailsApi, 
  setAccountDetails, 
  setBypassAccountDetailsCache, 
  setAccountDetailsCacheTimeStampValue, 
  setDisplayPrePayButton, 
  setDisplayEasyPayButton,
  setUpdatedCustNo, 
  setUpdatedAddress, 
  setUpdatedZipValue, 
  setInitialLoading,
  setPreferredEmail, 
  setAccountSummaryData,
  setIsOverlayLoading,
  setSelectedServiceAddress,
  setEasyPayEnrollAgrNum 
} = accountSummarySlice.actions;
export default accountSummarySlice.reducer;